module.exports = __webpack_public_path__ + "img/user.1f9568b7.png";